interface SortableHeaderProps {
  label: string;
  sortKey: string;
  sortConfig?: { key: string; direction: 'asc' | 'desc' };
  onSort: (key: string) => void;
  minWidth?: number;
  width?: number;
}

const SortableHeader: React.FC<SortableHeaderProps> = ({
  label,
  sortKey,
  sortConfig,
  onSort,
  minWidth = 150,
  width,
}) => {
  const isActive = sortConfig.key === sortKey;
  const directionArrow = isActive ? (sortConfig.direction === 'asc' ? <i className="bi bi-caret-up-fill ms-1"></i> : <i className="bi bi-caret-down-fill ms-1"></i>) : '';

  return (
    <th
      style={{ minWidth, width }}
      onClick={() => onSort(sortKey)}
      className="sortable-header"
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') onSort(sortKey);
      }}
    >
      {label}{directionArrow}
    </th>
  );
};

export default SortableHeader;
